import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "c-common-inner" }
const _hoisted_2 = { class: "p-the-a01-earn-point__intro" }
const _hoisted_3 = {
  id: "earn-point-title",
  class: "p-the-a01-earn-point__title"
}
const _hoisted_4 = { "data-translate-skip": "" }
const _hoisted_5 = { class: "p-the-a01-earn-point__examples" }
const _hoisted_6 = { class: "p-the-a01-earn-point__list" }
const _hoisted_7 = { class: "p-the-a01-earn-point__icon" }
const _hoisted_8 = { class: "p-the-a01-earn-point__item-body" }
const _hoisted_9 = {
  class: "p-the-a01-earn-point__name",
  "data-translate-skip": ""
}
const _hoisted_10 = {
  class: "p-the-a01-earn-point__point",
  "data-translate-skip": ""
}
const _hoisted_11 = { class: "p-the-a01-earn-point__point__body" }
const _hoisted_12 = { class: "p-the-a01-earn-point__point__value" }
const _hoisted_13 = { class: "p-the-a01-earn-point__point__unit" }
const _hoisted_14 = {
  key: 0,
  class: "p-the-a01-earn-point__text",
  "data-translate-skip": ""
}
const _hoisted_15 = {
  key: 0,
  class: "p-the-a01-earn-point__footer"
}
const _hoisted_16 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconInvestedRounded = _resolveComponent("IconInvestedRounded")!
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: "p-the-a01-earn-point",
        style: _normalizeStyle({ '--site-light-color': _ctx.lightColorCode }),
        "aria-labelledby": "earn-point-title"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.pointName), 1),
              _cache[0] || (_cache[0] = _createTextVNode("を獲得する方法 ", -1))
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "p-the-a01-earn-point__description" }, " ポイントは、組織ごとに定められた条件に基づいて付与されます。どのような条件やタイミングで付与されるのか、付与基準をご確認ください。 ", -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "p-the-a01-earn-point__examples-title" }, "付与基準例", -1)),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditions, (condition) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: condition.id,
                  class: "p-the-a01-earn-point__item"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_IconInvestedRounded, {
                      type: _ctx.iconType(condition),
                      "icon-size": 36,
                      "bg-color": _ctx.colorCode,
                      "icon-color": "#ffffff"
                    }, null, 8, ["type", "bg-color"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(condition.name), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "p-the-a01-earn-point__point__sign" }, "+", -1)),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.addComma(condition.points)), 1),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.pointName), 1)
                      ])
                    ]),
                    (condition.text)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(condition.text), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]),
            (_ctx.showMore)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("a", {
                    href: _ctx.urlGrantCriteria,
                    class: "p-the-a01-earn-point__more"
                  }, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "p-the-a01-earn-point__more__label" }, " 付与基準をもっと見る ", -1)),
                    _createVNode(_component_IconBase, {
                      class: "p-the-a01-earn-point__more__icon",
                      "view-box": "0 0 24 24",
                      width: 24,
                      height: 24,
                      "icon-color": _ctx.colorCode
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconArrowRight)
                      ]),
                      _: 1
                    }, 8, ["icon-color"])
                  ], 8, _hoisted_16)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 4))
    : _createCommentVNode("", true)
}